import COMMON_CATEGORIES from 'config/constants/common-categories';
const { wetFood, dryFood, snacks } = COMMON_CATEGORIES;

// translated string: wetFood = 'Nassfutter' e.t.c.
export type BundleCategoryKey = typeof wetFood | typeof dryFood | typeof snacks;

/**
 * Defines the order of prioritisation during the bundle products distribution
 * - the case when the amount of products does not match the BUNDLE_COMPOSITION_DICTIONARY
 * Order is different from dictionary
 */
export const PRIORITISATION_RANK: BundleCategoryKey[] = [wetFood, snacks, dryFood];

/**
 * Order of categories to build the preview of the bundle and categories inside
 * of the dynamic bundle controller
 */
export const CATEGORY_ORDER = [wetFood, dryFood, snacks] as BundleCategoryKey[];
// hardcoded default value for the first version
export const DYNAMIC_BUNDLE_DISCOUNT_PERCENT_CATS = 30;
export const DYNAMIC_BUNDLE_DISCOUNT_PERCENT_DOGS = 15;
export const COUNT_SYMBOL = 'X';

/**
 * Defines how many products should be in the bundle as absolute minimum.
 * Affects products distribution logic.
 * Defines rendering condition of dynamic bundle
 */
export const MINIMUM_PRODUCTS_IN_BUNDLE = 5;

/**
 * Minimum default-state value for the dynamic bundle, in cents.
 * When the default bundle's wet food + snacks gross-after-discount value is
 * below this threshold, wetFood amountPerItem is escalated step by step
 * through WET_FOOD_AMOUNT_ESCALATION_STEPS until the threshold is met or the
 * last step is reached (no further escalation beyond the last step).
 */
export const DEFAULT_VALUE_THRESHOLD_CENTS = 2900;
export const WET_FOOD_AMOUNT_ESCALATION_STEPS: number[] = [3, 4];
